<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dCYeVP/images/e9781439632451_cover.jpg?1684305911325" alt="This image is the cover for the book Ocean City, New Jersey, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ocean City, New Jersey, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Ocean City, which calls itself "America's Greatest Family Resort," is best known for its clean beaches and yearly bayfront celebration called the "Night in Venice." </b></p><br/><p>Founded in 1879 as a Christian seaside resort, the island community still maintains some of its early traditions including prohibiting the sale of alcoholic beverages--while striving to continue its long-standing reputation as a family-oriented resort. This remarkable new photographic history features such historic sites as the home of the town's first<br/>resident and famous old-time restaurants like Chris', Hogate's, and Watson's. Several rare pictures of the shipwrecked Sindia and its cargo are also included, as well as photographs of Ocean City's most well-known citizens, Princess Grace Kelly and author Gay Talese.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frank J. Esposito, Robert J. Esposito
      </h2>
      
      <p class="authorDescription body article">Authors Frank J. and Robert J. Esposito--father and son--have worked together to produce an exciting and lively trip into the past of this dynamic seashore community. Residents and visitors alike will surely cherish their enthusiasm and expertise for years to come.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3dcf228c